export const loadDashboardContainer = () => import('./containers/DashboardContainer.jsx')

export const loadDashboardReducer = () => import('./reducers')

export const loadDevicesControlTab = () =>
  import('./components/DevicesControlTab/DevicesControlTab')

export const preloadDashboardRoute = () =>
  Promise.all([loadDashboardContainer(), loadDashboardReducer(), loadDevicesControlTab()])
